// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","active":"Header_active__rHuVo"};